import isServerSideRendering from './isServerSideRendering';

/**
 * Sends the browser focus to the top (smoothly).
 * Safe to invoke on the server, however it won't do anything.
 */
function scrollWindowToTop() {
  if (!isServerSideRendering()) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

export default scrollWindowToTop;
